"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetTypeToJSON = exports.AdSetTypeFromJSONTyped = exports.AdSetTypeFromJSON = exports.AdSetType = void 0;
/**
 * Audience segment the ad set is targeting.
 * @export
 */
exports.AdSetType = {
    Exposed: 'EXPOSED',
    Control: 'CONTROL'
};
function AdSetTypeFromJSON(json) {
    return AdSetTypeFromJSONTyped(json, false);
}
exports.AdSetTypeFromJSON = AdSetTypeFromJSON;
function AdSetTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdSetTypeFromJSONTyped = AdSetTypeFromJSONTyped;
function AdSetTypeToJSON(value) {
    return value;
}
exports.AdSetTypeToJSON = AdSetTypeToJSON;
